import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Category,CategoryService } from './category.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}
let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.product)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/product/category.component.html'}
}
else
{
   componentdata={template: '<div></div>'}
   
}
@Component(componentdata)
/*
@Component({
	//template: require('./category.component.html')
	templateUrl: './pg/product/category.component.html',
	
})*/

export class CategoryComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    public category;    
    public products:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private _pageService: CategoryService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    this.slimLoadingBarService.start();
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			this.category=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   			   
			   
			   this._pageService.getProductlist(slug).subscribe(
        data => {
                 //     
                  //console.log(JSON.stringify(data.data));            
                  this.pagedata.title=data.menu.link_showing_name;
                  //this.pagedata.description=data.menu.description;                 
                  if(data.menu.link_showing_name)
                  this._title.setTitle(data.menu.link_showing_name);
                  else
                  this._title.setTitle(data.menu.link_showing_name);                  
                  this.products=data.product;
                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
               this.slimLoadingBarService.complete();
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/product/category.component.ts